const EMAIL_REGEX = /^\S+@\S+\.\S+$/

const isEmpty = (value?: string | null): boolean => value == null || value.trim() === ''

export class StringValidator {
  private _rules: ((value?: string | null) => string)[] = []

  public required() {
    this._rules.push((value) => (value ? '' : 'VALIDATOR_REQUIRED'))
    return this
  }

  public email() {
    this._rules.push((value) => (isEmpty(value) || EMAIL_REGEX.test(value!) ? '' : 'VALIDATOR_EMAIL'))
    return this
  }

  public minLength(length: number) {
    this._rules.push((value) => (isEmpty(value) || value!.trim().length >= length ? '' : 'VALIDATOR_MIN_LENGTH'))
    return this
  }

  public maxLength(length: number) {
    this._rules.push((value) => ((value ?? '').length <= length ? '' : 'VALIDATOR_MAX_LENGTH'))
    return this
  }

  public numeric() {
    this._rules.push((value) => (isEmpty(value) || !Number.isNaN(Number(value)) ? '' : 'VALIDATOR_NUMERIC'))
    return this
  }

  public pattern(regex: RegExp) {
    this._rules.push((value) => (isEmpty(value) || regex.test(value!) ? '' : 'VALIDATOR_PATTERN'))
    return this
  }

  public oneOf(allowed: string[]) {
    this._rules.push((value) => (isEmpty(value) || allowed.includes(value!) ? '' : 'VALIDATOR_ONE_OF'))
    return this
  }

  public custom(rule: (value?: string | null) => string) {
    this._rules.push(rule)
    return this
  }

  public validate(value?: string | null) {
    const errors = this._rules.map((r) => r(value)).filter((e) => e.length)
    return {
      valid: !errors.length,
      errors,
    }
  }
}

export class Validator {
  public string() {
    return new StringValidator()
  }
}
